import { render, staticRenderFns } from "./TheTestimonials.vue?vue&type=template&id=75657f06&scoped=true"
import script from "./TheTestimonials.vue?vue&type=script&lang=js"
export * from "./TheTestimonials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75657f06",
  null
  
)

export default component.exports